<template>
    <v-dialog v-model="show" width="250px" @click:outside="close()">
        <div id="qr-reader" width="600px">
            <v-card v-if="errMessage" class="red--text text-center pa-3">{{ errMessage }}</v-card>
        </div>
    </v-dialog>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";

export default {
    data: () => ({
        show: false,
        loading: false,

        errMessage: "",

        scanner: null,
    }),
    methods: {
        onScanSuccess (decodedText, decodedResult) {
            console.log(decodedText)
            this.$emit('result', decodedText, decodedResult);
            this.close()
        },
        open() {
            this.show = true

            setTimeout(() => {
                this.scanner = new Html5Qrcode("qr-reader")
                this.scanner.start(
                    { facingMode: "environment" },
                    {
                        fps: 30,
                        qrbox: { width: 250, height: 250 }
                    },
                    (decodedText, decodedResult) => {
                        this.$emit('result', decodedText, decodedResult);
                        this.close()
                    },
                    (errorMessage) => {
                        this.errMessage = errorMessage
                    }
                ).catch((err) => {
                    this.errMessage = "Couldn't start camera!"    
                })
            }, 1)
        },
        close() {
            // this.$emit('reload')
            try {
                this.scanner.stop()
            } catch (error) {}
            this.resetData()
        },
        resetData() {
            Object.assign(this.$data, this.$options.data())
        },
    },
}
</script>

<style>

</style>